import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull/components/OverlayContext';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { BusinessChannelEventBinder } from '~/pusher/BusinessChannelEventBinder';
import { PusherEvent } from '~/pusher/model';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import { IntegrationStatus } from '~/types/api.model';
import XeroLogo from '../../assets/XeroLogo';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
const connectionInProgressCardProps = ()=>{
    return {
        subTitle: 'Set up your Xero account connection.',
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            loading: true,
            loadingText: "Connection in progress",
            testId: "xero-card-connection-in-progress",
            children: "Connection in progress"
        })
    };
};
const connectCardProps = (param)=>{
    let { handleConnect } = param;
    return {
        subTitle: 'Connect your account to sync between Anchor and Xero',
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            testId: "xero-card-connect-button",
            onClick: handleConnect,
            children: "Connect"
        })
    };
};
const manageCardProps = (param)=>{
    let { companyName, handleManage } = param;
    return {
        subTitle: "Set up your Xero account connection with ".concat(companyName),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            testId: "xero-card-manage-button",
            onClick: handleManage,
            children: "Manage connection"
        })
    };
};
export default function XeroCard() {
    const { startLoader, stopLoader } = useOverlayContext();
    const { changeLocation } = useIoContext();
    const { api, fetchIntegrations, logBI } = useStoreActions();
    const history = useHistory();
    const xeroIntegrationInStore = useStore(selectors.integration.xeroIntegration);
    if (!xeroIntegrationInStore) {
        return null;
    }
    const handleConnect = async ()=>{
        logBI(18600);
        startLoader();
        const integration = await api.xero.connect({
            redirectUrl: "http://".concat(window.location.host).concat(routes.availableApps)
        });
        if (integration.linkUrl) {
            const connectUrl = new URL(integration.linkUrl);
            changeLocation(connectUrl.toString());
        } else {
            stopLoader();
        }
    };
    const handleManage = async ()=>{
        logBI(18601);
        history.push(routes.xeroSetup);
    };
    function onPusherIntegrationEvent() {
        fetchIntegrations();
    }
    const integrationCardProps = ()=>{
        switch(xeroIntegrationInStore.status){
            case IntegrationStatus.Linked:
                {
                    return xeroIntegrationInStore.isReady() ? manageCardProps({
                        companyName: xeroIntegrationInStore.companyName() || 'your account',
                        handleManage: handleManage
                    }) : connectionInProgressCardProps();
                }
            case IntegrationStatus.Unlinked:
                {
                    return connectCardProps({
                        handleConnect
                    });
                }
            default:
                {
                    return connectCardProps({
                        handleConnect
                    });
                }
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BusinessChannelEventBinder, {
                source: "mgmt",
                eventName: PusherEvent.IntegrationEvent,
                callback: onPusherIntegrationEvent
            }),
            /*#__PURE__*/ _jsx(IntegrationCard, _object_spread({
                testId: "xero-card",
                icon: /*#__PURE__*/ _jsx(XeroLogo, {}),
                title: "Xero"
            }, integrationCardProps()))
        ]
    });
}
